<!-----------------------------------------------------------------------------
  - Copyright (c) 2018. keni <$email>                                         -
  -                                                                           -
  - This file AccountEvent.vue is part of event_pass_client.dev.              -
  - Unauthorized copying of this file, via any medium is strictly prohibited. -
  - Proprietary and confidential                                              -
  - AccountEvent.vue can not be copied and/or distributed                     -
  - without the express permission of keni                                    -
  ----------------------------------------------------------------------------->

<!--//Created by keni.-->
<!--//User: keni-->
<!--//Date: 23/03/2018-->
<!--//Time: 14:32-->

<template>
    <div data-event-list class="mb-2">
        <div data-event-list
                v-if="size(events) > 1"
        >

        </div>
        <event-list
                data-event-list
                v-else
                location_link="false"
                :item="first(events)"
                :path="{
                    data:'event_data'
                }"
        />
    </div>
</template>

<script>
	export default {
		name: "account-event",
		components: {},
		props: ['event'],
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {}
		},
		methods: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/account/AccountEvent.vue